import React from 'react';

export const TermsOfUsePopup: React.FC = () => {
  return (
    <div style={{ textAlign: 'left',  overflowY: 'auto', padding: '1rem' }}>
      <h3>1. Terms of use</h3>
      <p>
      Access to, and use of, the Infrastructure Australia Data Platform is subject to these terms of use. These terms of use may change over time. The terms of use current at a given time are those published on this page at that time.
      </p>
      <p>
      By accessing or using the Infrastructure Australia Data Platform, you agree to be bound by these terms of use current at that time.
      </p>
      <p>
        You are responsible for the security and use of your Market Capacity user account. You
        must comply with all security requirements and instructions provided by Infrastructure
        Australia about your use of the Market Capacity Platform.
      </p>

      <p>a) You are responsible for the security and use of your Infrastructure Australia Data Platform user account. Your access to the Infrastructure Australia Data Platform occurs through and depends on: </p>
      <ul>
        <li>your employment with the agency or department you are engaged by and the Microsoft work account allocated to you; </li>
        <li>use of multi-factor authentication that has been allocated to you;</li>
        <li>you complying with all security requirements and instructions provided by Infrastructure Australia about your use of the Infrastructure Australia Data Platform.
        </li>

      </ul>

      <p>
        b) In the event that your User Account is inactive for over 45 days your access will automatically be disabled. To reactivate your account please contact IA via: <a href="mailto:scenario.modelling@infrastructureaustralia.gov.au" style={{ color: '#005670' }}>scenario.modelling@infrastructureaustralia.gov.au</a>
      </p>

      <p>c) You must:</p>
      <ul>
        <li>provide information that is true, accurate, current and complete to create your Infrastructure Australia Data Platform account and verify your identity; </li>
        <li>not use your Credentials for any unlawful or improper purpose;</li>
        <li>not disclose your Credentials to any other person;</li>
        <li>contact Infrastructure Australia if you believe the security of your Infrastructure Australia Data Platform account or Credentials have been compromised.</li>
        <p> The Glossary below has more information about some terms used in this document.</p>
        </ul>
      <hr />

      <h3>2. Infrastructure Australia Data Platform provided as is</h3>
      <p>
      The Infrastructure Australia Data Platform is a national database of infrastructure projects and includes, but is not limited to,  the Market Capacity Database; the Market Capacity Pipeline Simulator; and the National Market Capacity Map and the software that underpins these tools.
      </p>
      <p>The Infrastructure Australia Data Platform works optimally using the Microsoft Edge Browser and must be accessed via a valid Microsoft work account.  Infrastructure Australia makes no guarantee that the Infrastructure Australia Data Platform will function outside supported platforms.
      </p>
      <p>
      To the extent permitted by law, Infrastructure Australia:
      </p>

      <ul>
        <li>provides each of those elements of the Infrastructure Australia Data Platform ‘as is’ and without charge</li>
        <li>gives no express or implied warranties or makes any representation (and to the full extent permitted by law excludes all statutory warranties) for each of those elements (including its availability, security, performance or fitness for a particular purpose)
        </li>
        <li>will not be liable for any loss or damage (including special, indirect or consequential) arising from or in connection with any of those elements of the Infrastructure Australia Data Platform or its availability, use or performance either directly or through a third-party provider.
        </li>
      </ul>
      <p>To the extent that Infrastructure Australia's liability for the Infrastructure Australia Data Platform (or any part of it) cannot be excluded, it is limited to the resupply of the relevant goods or services, or the cost of such resupply, at Infrastructure Australia's option, or otherwise limited to the minimum amount permitted by law.
      </p>

      <hr />
      <h3>3. Use of Infrastructure Australia Data Platform</h3>
      <p>Infrastructure Australia, in line with terms of collaboration deeds in place with each jurisdiction, has developed the Infrastructure Australia Data Platform from information provided by each jurisdiction to:
      </p>
          <ul>
        <li>
        construct and maintain diagnostic tools;
        </li>
        <li>
        develop reporting and analysis for the Australian Government and published reports, 
        </li>
      </ul>
      <p>Confidential information is aggregated or de-identified to ensure the confidential information cannot be identified and/or derived from the data.
      </p>
      <p>
      Infrastructure Australia makes the Infrastructure Australia Data Platform available to you to use in Australia, in unaltered form, solely for use in accordance with these terms.
      </p>
      <p>
      You must not: 
      </p>

      <ul>
        <li>access the Infrastructure Australia Data Platform and material held within it other than through the means approved by Infrastructure Australia; </li>
        <li>decompile, reverse engineer, disassemble or attempt to derive the source code for the Infrastructure Australia Data Platform;</li>
        <li>create derivative works based on the Infrastructure Australia Data Platform or modify it in any way;</li>
        <li>distribute copies of the software/ Infrastructure Australia Data Platform or versions of it;</li>
        <li>use the Infrastructure Australia Data Platform for compliance or regulatory purposes  ;</li>
        <li>attempt to identify particular projects or organisations to which the Aggregated Data relates;</li>
        <li>disclose to anyone (other than Infrastructure Australia) any instance where you may have identified a particular project or organisation from the Aggregated Data;</li>
        <li>make an attempt to match, with or without using identifiers, the Aggregated Data with any other list, database or repository of information;</li>
        <li>attempt to avoid, override or otherwise circumvent the controls put in place by Infrastructure Australia around the procedures and mode of access, including clearance of output, which are designed to prevent any deliberate or inadvertent breach of these terms;</li>
        <li>disclose the Aggregated Data to anyone without the approval of Infrastructure Australia or an authorised delegate and will immediately report to Infrastructure Australia any possible unauthorised disclosure that may have occurred .</li>
      </ul>
      <p>
      You must comply with any other requirements notified by Infrastructure Australia, from time to time, regarding access to and use of the Infrastructure Australia Data Platform.
      </p>

      <p>
      You must ensure your use of the Infrastructure Australia Data Platform complies with all applicable conditions of use, including third-party software licensing conditions of use, relevant laws, including local laws in any relevant state or territory. 
      </p>
      <p>
      The Platform uses third-party software Tableau and Microsoft under licence. 
      </p>
      <hr />

      <h3>4. Infrastructure Australia Data Platform availability</h3>
      <p>
      You can access and use the Infrastructure Australia Data Platform through your User Account. While Infrastructure Australia will use reasonable efforts to rectify any issues with the Infrastructure Australia Data Platform that it is aware of:
      </p>
      <ul>
        <li>
        Infrastructure Australia makes no guarantees that the Infrastructure Australia Data Platform, and your access to it (and your Infrastructure Australia user account), will be continuously available, uninterrupted, and fault or error free; 
        </li>
        <li>
        your access to the Infrastructure Australia Data Platform (and your User Account) is contingent on telecommunication services and other factors beyond Infrastructure Australia’s control; and
        </li>
        <li>
        Infrastructure Australia may suspend or terminate access to the Infrastructure Australia Data Platform through some or all products or to some or all users at any time.
        </li>
      </ul>
      <p>
      You should take appropriate and adequate precautions to ensure that the information obtained from the Infrastructure Australia Data Platform is free of viruses or other contamination that may interfere with or damage your systems, devices or data.
      </p>
      <p>
      You can email us for information about our Infrastructure Australia Data Platform at <a href="mailto:scenario.modelling@infrastructureaustralia.gov.au" style={{ color: '#005670' }}>scenario.modelling@infrastructureaustralia.gov.au</a>.
      </p>

      <hr />

      <h3>5. Infrastructure Australia credentials</h3>
      <p>
      You are responsible for all transactions and communications carried out using your Credentials, and for the security and use of your User Account and the work device on which it is stored or work device used to authenticate. 
      </p>
      <p>
        You are responsible for all transactions and communications carried out using your Market
        Capacity Platform credential, and for the security and use of your user account and the
        device on which it is stored or device used to authenticate.
      </p>
      <p>You must:</p>
      <ul>
        <li>not use your Credentials for any unlawful or improper purpose;</li>
        <li>not disclose your User Account or Credentials to any other person;</li>
        <li>
        not store your Credentials in a place which any other person has access, or otherwise allow, grant, permit or enable any other person to use your Credentials;
        </li>
        <li>
        not undertake any screen capture, sharing or like activities that might compromise the security of your User Account or Credentials; and
        </li>
        <li>
        contact Infrastructure Australia as soon as you suspect or become aware that the security of your User Account or Credentials have been compromised.
        </li>
      </ul>

      <hr />

      <h3>6. General</h3>
      <p>
      Infrastructure Australia will collect, use, store and share your personal and sensitive information as detailed in the Privacy Policy.  Infrastructure Australia will disclose your personal information to third parties if you have provided your express consent to do so, or if authorised or required by law.
      </p>
      <p>
      You acknowledge that Infrastructure Australia may suspend, cancel or revoke your Credentials if you breach these terms or are no longer eligible to hold a User Account. If you no longer wish to use the Infrastructure Australia Data Platform, you may contact Infrastructure Australia via <a href="mailto:scenario.modelling@infrastructureaustralia.gov.au" style={{ color: '#005670' }}>scenario.modelling@infrastructureaustralia.gov.au</a> and request to be disconnected from the Infrastructure Australia Data Platform.
      </p>
      <p>
      Any disputes between you and any third-party provider of the Infrastructure Australia Data Platform, must be resolved between you and that party.
      </p>
      <p>
      These terms of use constitute the entire agreement between you and Infrastructure Australia as administrator of the Infrastructure Australia Data Platform. They supersede all prior communications, representations, agreements or understanding about these terms.
      </p>

      <hr />

<strong>Term and Definition Table</strong>
<table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }} border={1}>
  <thead>
    <tr>
      <th style={{ padding: '8px' }}>Term</th>
      <th style={{ padding: '8px' }}>Definition</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style={{ padding: '8px' }}>Aggregated Data</td>
      <td style={{ padding: '8px' }}>
        Data held in the Infrastructure Australia Data Platform is aggregated by collecting up individual
        project submissions from states and territories.
      </td>
    </tr>
    <tr>
      <td style={{ padding: '8px' }}>Credentials</td>
      <td style={{ padding: '8px' }}>
        To access the Infrastructure Australia Data Platform the following information is required for each user:
        <ul>
          <li>a distinguishable name to identify an individual user;</li>
          <li>password that complies with agency security requirements; and</li>
          <li>Multi-Factor Authentication (MFA), Microsoft Authenticator App or MFA Number matching</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td style={{ padding: '8px' }}>Infrastructure Australia Data Platform</td>
      <td style={{ padding: '8px' }}>
        Is a national database of infrastructure projects which includes, but is not limited to, the Market Capacity Database; 
        the Market Capacity Pipeline Simulator; and the National Market Capacity Map and the software that underpins these tools.
      </td>
    </tr>
    <tr>
      <td style={{ padding: '8px' }}>User Account</td>
      <td style={{ padding: '8px' }}>
        Individual user account linked to a Microsoft work account issued by a participating commonwealth, 
        state or territory department or agency accessed via Credentials to the Infrastructure Australia Data Platform.
      </td>
    </tr>
  </tbody>
</table>

<hr />


<p>If you have any questions and concerns about the Terms of Use please contact <a href="mailto:scenario.modelling@infrastructureaustralia.gov.au" style={{ color: '#005670' }}>scenario.modelling@infrastructureaustralia.gov.au</a></p>
    </div>
  );
};
